import React from 'react';
import { useActiveTab } from '../../../hooks/useActiveTab';

export const TabNavigation = () => {
  const [activeTab, setActiveTab] = useActiveTab();

  return (
    <div className="tab-navigation">
      <button
        className={`tab-button ${activeTab === 'whatsapp' ? 'active' : ''}`}
        onClick={() => setActiveTab('whatsapp')}
      >
        <img src="/whatsapp.png" alt="WhatsApp" className="tab-icon" />
        WhatsApp
      </button>
      <button
        className={`tab-button ${activeTab === 'prodyt' ? 'active' : ''}`}
        onClick={() => setActiveTab('prodyt')}
      >
        <img src="/prodyt.png" alt="Prodyt CRM" className="tab-icon" />
        Prodyt CRM
      </button>
    </div>
  );
};

export default TabNavigation;
